import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import { useBreakpointValue, chakra, Skeleton } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
var _excluded = ["noOfLines", "spacing", "skeletonHeight", "className", "startColor", "endColor", "isLoaded", "fadeDuration", "speed", "children"];
function range(count) {
  return Array(count).fill(1).map(function (_, index) {
    return index + 1;
  });
}
var defaultNoOfLines = 3;
var SkeletonText = function SkeletonText(props) {
  var _props$noOfLines = props.noOfLines,
    noOfLines = _props$noOfLines === void 0 ? defaultNoOfLines : _props$noOfLines,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? '0.5rem' : _props$spacing,
    _props$skeletonHeight = props.skeletonHeight,
    skeletonHeight = _props$skeletonHeight === void 0 ? '1rem' : _props$skeletonHeight,
    className = props.className,
    startColor = props.startColor,
    endColor = props.endColor,
    isLoaded = props.isLoaded,
    fadeDuration = props.fadeDuration,
    speed = props.speed,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var noOfLinesValue = useBreakpointValue(typeof noOfLines === 'number' ? [noOfLines] : noOfLines) || (typeof noOfLines === 'number' ? noOfLines : defaultNoOfLines);
  var numbers = range(noOfLinesValue);
  var getWidth = function getWidth(index) {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? '80%' : '100%';
    }
    return '100%';
  };
  var _className = cx('chakra-skeleton__group', className);
  return /*#__PURE__*/React__default.createElement(chakra.div, _extends({
    className: _className
  }, rest), numbers.map(function (number, index) {
    if (isLoaded && index > 0) {
      // skip other lines
      return null;
    }
    var sizeProps = isLoaded ? null : {
      mb: number === numbers.length ? '0' : spacing,
      width: getWidth(number),
      height: skeletonHeight
    };
    return /*#__PURE__*/React__default.createElement(Skeleton, _extends({
      key: numbers.length.toString() + number,
      startColor: startColor,
      endColor: endColor,
      isLoaded: isLoaded,
      fadeDuration: fadeDuration,
      speed: speed
    }, sizeProps),
    // allows animating the children
    index === 0 ? children : undefined);
  }));
};
export { SkeletonText };